import { Component, Input, OnInit } from '@angular/core';
import { ProductItems } from '../../../../../../models/product/get-product-request';

@Component({
  selector: 'product-pricing-view',
  templateUrl: './product-pricing-view.component.html',
  styleUrls: ['./product-pricing-view.component.scss'],
})
export class ProductPricingViewComponent implements OnInit {
  @Input() productItem: ProductItems | null = null;

  constructor() {}

  ngOnInit(): void {}

  get costPrice(): string {
    // ProductItems doesn't have CostPrice, calculate from PublishedPrice (assuming 20% markup)
    if (this.productItem?.PublishedPrice) {
      const estimatedCost = this.productItem.PublishedPrice * 0.8;
      return `₱${estimatedCost.toFixed(2)}`;
    }
    return 'Not specified';
  }

  get sellingPrice(): string {
    // ProductItems doesn't have SellingPrice, use PublishedPrice minus VAT
    if (this.productItem?.PublishedPrice) {
      const sellingPrice = this.productItem.PublishedPrice / 1.12; // Remove 12% VAT
      return `₱${sellingPrice.toFixed(2)}`;
    }
    return 'Not specified';
  }

  get vatAmount(): string {
    // Calculate VAT from PublishedPrice (12% VAT)
    if (this.productItem?.PublishedPrice) {
      const vatAmount = this.productItem.PublishedPrice - (this.productItem.PublishedPrice / 1.12);
      return `₱${vatAmount.toFixed(2)}`;
    }
    return '₱0.00';
  }

  get displayedPrice(): string {
    return this.productItem?.PublishedPrice ? `₱${this.productItem.PublishedPrice.toFixed(2)}` : 'Not specified';
  }

  get isVatable(): string {
    // ProductItems doesn't have UseVat, using placeholder
    return 'Yes, includes VAT';
  }

  get profitMargin(): string {
    // Calculate profit margin from estimated values
    if (this.productItem?.PublishedPrice) {
      const costPrice = this.productItem.PublishedPrice * 0.8;
      const sellingPrice = this.productItem.PublishedPrice / 1.12;
      const profit = sellingPrice - costPrice;
      const margin = (profit / sellingPrice) * 100;
      return `₱${profit.toFixed(2)} (${margin.toFixed(1)}%)`;
    }
    return 'Cannot calculate';
  }

  get hasVat(): boolean {
    // Placeholder - in real implementation this would come from product data
    return true;
  }
}
